import { render, staticRenderFns } from "./DeclinedDialog.vue?vue&type=template&id=6c5ca619&scoped=true&"
import script from "./DeclinedDialog.vue?vue&type=script&lang=js&"
export * from "./DeclinedDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeclinedDialog.vue?vue&type=style&index=0&id=6c5ca619&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ca619",
  null
  
)

export default component.exports